import React from 'react';
export function ProofSection() {
  return <section className="bg-cream py-20 md:py-28 relative overflow-hidden" data-id="element-116">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-117">
        <div className="absolute -top-24 -left-24 w-64 h-64 border border-gold/20 rounded-full" data-id="element-118"></div>
        <div className="absolute -bottom-24 -right-24 w-96 h-96 border border-sage/40 rounded-full" data-id="element-119"></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl relative z-10" data-id="element-120">
        <div className="text-center mb-12" data-id="element-121">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-forest mb-6" data-id="element-122">
            Lo que cambia en 7 días
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto" data-id="element-123"></div>
        </div>

        <div className="bg-white p-10 md:p-16 rounded-sm shadow-2xl border border-gold/10 relative" data-id="element-124">
          {/* Large Quotation Marks */}
          <div className="absolute top-4 left-6 text-8xl font-heading text-gold/20 leading-none select-none" data-id="element-125">
            "
          </div>
          <div className="absolute bottom-[-2rem] right-6 text-8xl font-heading text-gold/20 leading-none select-none rotate-180" data-id="element-126">
            "
          </div>

          <p className="text-xl md:text-2xl lg:text-3xl font-heading italic text-forest leading-relaxed text-center relative z-10" data-id="element-127">
            En la primera semana, notarás que la presión en la cintura de tu
            ropa disminuye drásticamente, tus niveles de energía se mantienen
            estables durante la tarde y esa sensación de "globo" desaparece,
            permitiéndote sentirte ligera y cómoda en tu propia piel por primera
            vez en años.
          </p>
        </div>
      </div>
    </section>;
}